import { computed } from 'vue';
import VueRouter, { Route } from 'vue-router';

export const INTERFACE_FOCUSED_CODE = 'i';
export const LAYOUT_MODE_QUERY_PARAM = 'mode';
export const INTERFACE_QUERY_PARAM = 'i';

export const useFlowLayoutMode = (router: VueRouter, currentRoute: Route) => ({
	isNormalMode: computed({
		get: () => currentRoute.query[LAYOUT_MODE_QUERY_PARAM] !== INTERFACE_FOCUSED_CODE,
		set: (value) => {
			if (value) {
				// todo - need to choose interface
			} else {
				// todo - need to remove interface from query param
			}
			const queryWithoutMode = Object.fromEntries(Object.entries(currentRoute.query).filter(([key]) => key !== LAYOUT_MODE_QUERY_PARAM));
			const queryToPush = !value ? { ...queryWithoutMode, [LAYOUT_MODE_QUERY_PARAM]: INTERFACE_FOCUSED_CODE } : queryWithoutMode;
			router.push({ query: queryToPush });
		},
	}),
});
